export function openNewTab(url: string) {
    window.open(url, '_blank', 'noopener,noreferrer');
}
